import { Component, Fragment } from 'react'
import { ResourceType } from '@ds-frontend/resource'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import { PropTypes } from 'prop-types'

import HeaderQuote from '../widgets/HeaderQuote'
import AboutBoaView from './AboutBoaView'
import { Loading } from 'common/widgets'
import classNames from './styles.module.scss'


const propTypes = {
  aboutBoa: ResourceType.isRequired,
  quote: PropTypes.string.isRequired,
}

export default class AboutBoaContainer extends Component {
  render() {
    const data = get(this.props.aboutBoa, 'data', { content: [] })
    return (
      <Fragment>
        <HeaderQuote uuid={this.props.quote} />
        <Loading isLoading={isEmpty(this.props.aboutBoa.data)} className={classNames.loading}>
          <AboutBoaView data={data} quote={this.props.quote} />
        </Loading>
      </Fragment>
    )
  }
}

AboutBoaContainer.propTypes = propTypes
